module.exports = __webpack_public_path__ + "static/media/TOWER Website - Hero - main - 23 Dec 2022.4d9fc2da.svg";